export default __webpack_public_path__ + "static/media/image.ownline.6dc383b0.png";